"use client";
import styles from "./BuyingGuidesSideDrawer.module.scss";
import { Link } from "@/types/prodcatBaseTypes";
import { OpenInNewOutlined as OpenInNew24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import { Trigger } from "../__shared__/Trigger/Trigger";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

type Props = {
  links: Link[];
};

export function BuyingGuidesSideDrawerUI({ links }: Props) {
  const [open, setOpen] = useState(false);
  if (links.length < 1) return null;

  return (
    <>
      <Trigger
        label="Useful guides"
        onClick={withSideDrawerAnalytics("Useful Guides", () => setOpen(true))}
      />
      <SEOFriendlyDrawer
        isOpen={open}
        onClose={() => setOpen(false)}
        heading="Useful guides"
        primaryButtonText="Close"
      >
        <ul className={styles.buyingGuides}>
          {links.map(({ linkUrl, text }) => (
            <li key={linkUrl} className={styles.buyingGuide}>
              <span className={styles.buyingGuideName}>{text}</span>
              <div className={styles.linkDetails}>
                <UnderlinedButton
                  className={styles.externalButton}
                  tag="a"
                  target="_blank"
                  rel="noreferrer"
                  href={linkUrl}
                  labelText="View the guide"
                />
                <OpenInNew24PxOutlinedIcon size="medium" />
              </div>
            </li>
          ))}
        </ul>
      </SEOFriendlyDrawer>
    </>
  );
}
